import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { EasyDialog } from '@shared';
import { Router } from '@angular/router';

@Component({
  selector: 'app-editmodal',
  templateUrl: './editmodal.component.html',
  styleUrls: ['./editmodal.component.scss']
})
export class EditmodalComponent implements OnInit {

  constructor(private route: Router, private dialogRef: MatDialogRef<EditmodalComponent>, @Inject(MAT_DIALOG_DATA) public dialog: EasyDialog) { }
  approverType: string;
  types = [
    { value: 'Approve', label: 'Approve' },
    { value: 'Returned', label: 'Returned' },
  ];

  htmlstring = "a. We have done scrutiny of general ledger during the quarter ended September 2019.Our unresolved observations are given in Annexure-1 b. Excess payment of Rs 0.000367 mn was observed in the bills of Vanshka travels car rental company for the months of July & August 2019 c. Excess payment of Rs 0.000450 mn was made in the August bill of Red Sun Travels ( car rental company) d. The company bought few air tickets for its Japanese officials from a travel agency other than MATA during the quarter"
  quillConfig = {
    toolbar: [
      ['bold', 'italic', 'underline'],        // toggled buttons
      //  ['blockquote', 'code-block'],

      // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      // [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      // [{ 'direction': 'rtl' }],                         // text direction

      // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      //[{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      // [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      // [{ 'font': [] }],
      // [{ 'align': [] }],

      //['clean'],                                         // remove formatting button

      // ['link', 'image', 'video']                         // link and image, video
    ]
  };

  ngOnInit() {
  }

  closePopup() {
    this.dialogRef.close(true);
    return false;
  }

}
